// extracted by mini-css-extract-plugin
export var dropdownButton = "_1z-0";
export var fullWidthDropdownButton = "_1z-1";
export var icon = "_1z-3";
export var iconPlaceholder = "_1z-2";
export var menuItemRow = "_1z-8";
export var separator = "_1z-d";
export var shortcutContainer = "_1z-7";
export var shortcutIconLg = "_1z-6";
export var shortcutIconMd = "_1z-5";
export var shortcutIconSm = "_1z-4";
export var submenuChevron = "_1z-c";
export var submenuDropdown = "_1z-9";
export var submenuTriggerRow = "_1z-a";
export var submenuTriggerRowOpen = "_1z-b";